export const USE_PAGINATION_API = true
export const PAGE_IMAGE = "/images/headers/khub_program.png"
export const STATE_KEY = 'programs'
export const SORT_OPTIONS = ['date', 'title']
